import Resource from './common/resource';

class Views extends Resource {
  path = 'views';
}

export default Views;
